import { useAuth } from "../context/AuthContext";

const Topbar = () => {
  const { user } = useAuth();
  return (
    <div className="flex justify-between items-center bg-white shadow px-6 py-3">
      <p className="text-gray-700">{new Date().getHours() < 12 ? 'Good morning' : 'Good afternoon' }, Welcome Back!</p>
      <div className="flex items-center space-x-4">
        <span className="text-gray-600">{user?.fullName || 'User'}</span>
        <div className="w-8 h-8 bg-gray-300 rounded-full"></div>
      </div>
    </div>
  );
};

export default Topbar;
